<template>
<div id="app">
  <Navbar />
  <br/>
  <div class="container">
    <router-view :key="$route.path"/>
  </div>
</div>
</template>

<script>
import Navbar from '@/components/Navbar';

export default {
  name: 'App',
  components: { Navbar },
  mounted() {
    document.title = process.env.VUE_APP_UI.title;
  }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/App.vue